/**
 * Excel / CSV Parser Utilities
 */

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Fuzzy header matching for Name and Email columns
const NAME_KEYS = ['name', 'full name', 'fullname', 'student name', 'candidate name', 'intern name', 'participant'];
const EMAIL_KEYS = ['email', 'email address', 'e-mail', 'mail', 'emailid', 'email id'];

function findColumn(headers, candidates) {
  for (const h of headers) {
    if (candidates.includes(h.toLowerCase().trim())) return h;
  }
  return null;
}

export function validateEmails(rows, emailKey) {
  return rows.map(row => ({
    ...row,
    _emailValid: EMAIL_REGEX.test((row[emailKey] || '').trim()),
  }));
}

export function detectDuplicates(newRows, existingCandidates, emailKey) {
  const existingEmails = new Set(existingCandidates.map(c => c.email?.toLowerCase()));
  return newRows.map(row => ({
    ...row,
    _isDuplicate: existingEmails.has((row[emailKey] || '').toLowerCase().trim()),
  }));
}

export function parseCSVRows(results, existingCandidates = []) {
  const { data } = results;
  if (!data || data.length === 0) return { rows: [], nameKey: null, emailKey: null, errors: ['No data found'] };

  const headers = Object.keys(data[0]);
  const nameKey = findColumn(headers, NAME_KEYS);
  const emailKey = findColumn(headers, EMAIL_KEYS);

  if (!nameKey || !emailKey) {
    return {
      rows: [],
      nameKey,
      emailKey,
      errors: [`Could not auto-map columns. Found: ${headers.join(', ')}. Need Name and Email columns.`]
    };
  }

  let rows = data.filter(r => r[nameKey]?.trim());
  rows = validateEmails(rows, emailKey);
  rows = detectDuplicates(rows, existingCandidates, emailKey);

  return { rows, nameKey, emailKey, errors: [] };
}

export async function parseExcelFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        // Dynamic import of xlsx
        import('xlsx').then(XLSX => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
          resolve(jsonData);
        });
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
}
